(function() {

    'use strict';

    angular.module('app').config(marketPlaceConfig);

    marketPlaceConfig.$inject = ['$routeProvider', '$locationProvider'];

    function marketPlaceConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/marketplaces/view/:id', {
            templateUrl: '/templates/pages/marketplaces/view.html',
            controller: 'MarketPlaceViewController',
            controllerAs: 'vm',
            params: {
                parent: 'marketplaces',
                subParent: 'marketplacesConfiguration',
                htmlTitle: 'Marketplaces',
                pageTitle: 'Detailed Marketplace View'
            }
        });
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();


// WEBPACK FOOTER //
// ./js/urls/marketplaces.js